import { render, staticRenderFns } from "./CompText.vue?vue&type=template&id=440688eb"
import script from "./CompText.vue?vue&type=script&lang=js"
export * from "./CompText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports